var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"data-chart"},[_c('data-chart',{ref:"LineChart",attrs:{"title":_vm.title,"titleLeft":"center"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }